
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_QUOTE_RESULT = '[QUOTERESULT] Add';
export const REMOVE_QUOTE_RESULT = '[QUOTERESULT] Remove';

// AddPersonalDetails
export class AddQuoteResult implements Action {
    readonly type = ADD_QUOTE_RESULT;

    constructor(public payload: any) { }
}
// RemovePersonalDetails
export class RemoveQuoteResult implements Action {
    readonly type = REMOVE_QUOTE_RESULT;

    constructor(public payload: number) { }
}

export type Actions = AddQuoteResult | RemoveQuoteResult;
